module.exports = __webpack_public_path__ + "img/bg-galeria.5ee58918.png";